import React from 'react';
import { connect } from "react-redux";
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';
import { ReactComponent as SuccessIcon } from "../../../../_metronic/layout/assets/layout-svg-icons/Success.svg";
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { FormattedMessage, injectIntl } from "react-intl";


class ActionsEmailSubscriptionState extends React.Component {

  renderStatusIcon = () => {
    return (
      <span className="kt-svg-icon" style={{}}>
        <SuccessIcon />
      </span>
    )
  }
  render() {
    if (!this.props.subscription?.actionmailsubscriptionid) {
      return null;
    }
    return (
      <div >

        <Toolbar style={{ paddingLeft: 30, paddingRight: 30 }} >
          <ToolbarItem
            location='before'
            locateInMenu="never"
            render={this.renderStatusIcon}
          />
          <ToolbarItem
            location="before"
            widget="dxTextBox"
            options={{
              width: 500,
              readOnly: true,
              value: this.props.intl.formatMessage({ id: 'EMAIL_SUBSCRIPTION.LABEL.ACTIVE_SUBSCRIPTION' })
            }}
          />


        </Toolbar>
      </div>

    )
  }
}


export default injectIntl(ActionsEmailSubscriptionState);